export default "__VITE_ASSET__a2711fa3__"